import { __extends } from "tslib";
import { DetectProtectiveEquipmentRequest, DetectProtectiveEquipmentResponse } from "../models/models_0";
import { deserializeAws_json1_1DetectProtectiveEquipmentCommand, serializeAws_json1_1DetectProtectiveEquipmentCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DetectProtectiveEquipmentCommand = /** @class */ (function (_super) {
    __extends(DetectProtectiveEquipmentCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DetectProtectiveEquipmentCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DetectProtectiveEquipmentCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "RekognitionClient";
        var commandName = "DetectProtectiveEquipmentCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: DetectProtectiveEquipmentRequest.filterSensitiveLog,
            outputFilterSensitiveLog: DetectProtectiveEquipmentResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DetectProtectiveEquipmentCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1DetectProtectiveEquipmentCommand(input, context);
    };
    DetectProtectiveEquipmentCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1DetectProtectiveEquipmentCommand(output, context);
    };
    return DetectProtectiveEquipmentCommand;
}($Command));
export { DetectProtectiveEquipmentCommand };
//# sourceMappingURL=DetectProtectiveEquipmentCommand.js.map